// Shared emoji image mapping for all vocabulary words
// Maps Chinese word → emoji SVG filename (without .svg extension)
// These SVGs live in /public/images/emoji/

const imgMap: Record<string, string> = {
  // Greetings (问候语)
  '你好': 'wave', '再见': 'goodbye', '谢谢': 'thank_you', '对不起': 'sorry',
  '不客气': 'smile', '没关系': 'ok', '请': 'please', '早上': 'morning_rise',
  '晚上': 'evening_sky', '欢迎': 'hug', '认识': 'handshake', '高兴': 'grin',
  '名字': 'name_badge', '先生': 'mr_man', '小姐': 'miss_lady',

  // Numbers (数字)
  '一': '1', '二': '2', '三': '3', '四': '4',
  '五': '5', '六': '6', '七': '7', '八': '8',
  '九': '9', '十': 'ten', '百': '100', '千': 'thousand_num',
  '万': 'ten_k', '零': '0', '两': '2', '第一': 'gold_medal',
  '第二': 'silver_medal', '多少': 'how_many_q', '几': 'how_many2',
  '双': 'twins', '个': 'package', '岁': 'cake', '元': 'yen',
  '块': 'money_bag', '半': 'clock_half',

  // Family (家庭)
  '爸爸': 'father', '妈妈': 'mother', '哥哥': 'boy', '姐姐': 'girl',
  '弟弟': 'son', '妹妹': 'daughter', '爷爷': 'grandpa', '奶奶': 'grandma',
  '叔叔': 'uncle_man', '阿姨': 'aunt_woman', '儿子': 'son', '女儿': 'daughter',
  '孩子': 'baby', '家': 'house', '外公': 'grandpa', '外婆': 'grandma',
  '朋友': 'handshake', '家人': 'family_group', '邻居': 'person', '人': 'standing',

  // Food (食物)
  '饭': 'rice_bowl', '米饭': 'rice_bowl', '面条': 'noodles_bowl', '饺子': 'dumplings',
  '面包': 'bread_loaf', '鸡蛋': 'egg', '肉': 'meat_steak', '牛肉': 'beef_steak',
  '鸡肉': 'chicken_leg', '鱼': 'fish', '菜': 'vegetable_leaf', '水果': 'apple_fruit',
  '苹果': 'apple_fruit', '香蕉': 'banana_fruit', '西瓜': 'watermelon_fruit', '茶': 'tea_cup',
  '咖啡': 'coffee_cup', '水': 'water_drop', '牛奶': 'milk_glass', '果汁': 'juice_glass',
  '可乐': 'cola_drink', '好吃': 'good_taste', '甜': 'candy_sweet', '酸': 'lemon_sour',
  '辣': 'chili_pepper', '咸': 'salt_shaker', '饿': 'hungry_face', '渴': 'thirsty_drop',
  '吃': 'eat_fork', '喝': 'drink_sip',

  // Animals (动物)
  '狗': 'dog_pet', '猫': 'cat_pet', '鸟': 'bird_fly', '马': 'horse_run',
  '牛': 'cow_farm', '羊': 'sheep_wool', '猪': 'pig_farm', '鸡': 'chicken_barn',
  '鸭': 'duck_water', '兔': 'rabbit_jump', '老虎': 'tiger_wild', '大象': 'elephant_wild',
  '猴子': 'monkey_tree', '蛇': 'snake_crawl', '虫': 'insect_bug', '熊猫': 'panda_bamboo',
  '动物': 'lion_wild', '宠物': 'poodle_dog', '龙': 'dragon_myth', '游泳': 'swim', '飞': 'airplane',

  // Colors (颜色)
  '颜色': 'palette', '红': 'red_circle', '蓝': 'blue_circle', '绿': 'green_circle',
  '黄': 'yellow_circle', '白': 'white_circle', '黑': 'black_circle', '橙': 'orange_circle',
  '紫': 'purple_circle', '粉红': 'heart_pink', '灰': 'gray_circle', '棕色': 'brown_circle',
  '金色': 'star_glow', '银色': 'sparkles', '深': 'deep_color', '好看': 'heart_eyes',

  // Body (身体)
  '身体': 'standing', '头': 'boy', '眼睛': 'eye_single', '耳朵': 'ear',
  '鼻子': 'nose_svg', '嘴': 'mouth_svg', '手': 'hand_svg', '脚': 'foot_svg',
  '腿': 'leg_svg', '胳膊': 'arm_svg', '头发': 'haircut', '脸': 'smile',
  '牙': 'tooth_svg', '心': 'heart', '生病': 'sick_face',

  // Time (时间)
  '时间': 'clock_alarm', '今天': 'date_calendar', '明天': 'calendar2', '昨天': 'calendar3',
  '现在': 'watch', '以前': 'rewind', '以后': 'forward', '年': 'calendar3',
  '月': 'moon', '日': 'sun', '星期': 'date_calendar', '周末': 'party',
  '点': 'clock1', '分': 'stopwatch_svg', '秒': 'timer', '小时': 'hourglass_svg',
  '开始': 'start_flag', '结束': 'end_flag', '快': 'fast_zap', '慢': 'slow_snail',

  // Weather (天气)
  '天气': 'sun_cloud', '晴天': 'sunny', '阴天': 'cloudy', '下雨': 'rainy',
  '下雪': 'snowy', '风': 'windy_svg', '云': 'cloudy', '太阳': 'sunny',
  '月亮': 'moon', '星星': 'star', '热': 'hot_face', '冷': 'cold_face',
  '暖': 'sun_face', '凉': 'leaf', '温度': 'thermometer_svg',

  // School (学校)
  '学校': 'school_building', '老师': 'teacher_svg', '学生': 'student_svg', '同学': 'classmates',
  '教室': 'classroom', '书': 'book_read', '本子': 'notebook_svg', '笔': 'pen_svg',
  '字典': 'dictionary', '电脑': 'computer_svg', '作业': 'homework_svg', '考试': 'exam_paper',
  '问题': 'question_mark', '回答': 'answer_bubble', '学习': 'study_books', '教': 'teach_school',
  '懂': 'understand_light', '容易': 'easy_breeze', '难': 'hard_face', '练习': 'practice_hand',

  // Places (地方)
  '地方': 'pin_location', '厕所': 'restroom', '房间': 'bed_room', '公司': 'company',
  '商店': 'store_shop', '超市': 'supermarket', '医院': 'hospital', '银行': 'bank_svg',
  '饭店': 'restaurant', '机场': 'airport_svg', '车站': 'station_svg', '公园': 'park_svg',
  '图书馆': 'library', '办公室': 'company', '城市': 'big_city', '国家': 'country_globe',
  '中国': 'cn_flag', '北京': 'castle', '上海': 'night_city', '泰国': 'th_flag',

  // Verbs (动词)
  '做': 'hammer', '看': 'look_see', '听': 'listen', '说': 'speak_say',
  '写': 'write_pen', '读': 'read_aloud', '走': 'walk', '跑': 'run',
  '坐': 'sit', '站': 'stand', '睡': 'sleep_bed', '起': 'get_up',
  '开': 'open_door', '关': 'close_door', '买': 'cart', '卖': 'sell_tag',
  '送': 'gift', '拿': 'hand', '放': 'inbox', '找': 'search',
  '等': 'hourglass', '玩': 'gamepad', '工作': 'work_desk', '休息': 'rest_couch',
  '帮助': 'help_hand', '告诉': 'tell_mega', '知道': 'bulb',
  '会': 'can_do', '想': 'think_cloud', '要': 'want_point',
  '爱': 'heart_pink', '喜欢': 'heart', '去': 'go_arrow', '来': 'come_back',
  '住': 'live_home',

  // Adjectives (形容词)
  '大': 'big_up', '小': 'small_down', '多': 'many_plus', '少': 'few_minus',
  '新': 'sparkles', '旧': 'scroll', '好': 'thumbs_up', '坏': 'thumbs_down',
  '对': 'correct_yes', '错': 'wrong_x',
  '忙': 'busy_rush', '累': 'tired', '贵': 'gem', '便宜': 'dollar',
  '远': 'telescope', '近': 'pin_location', '高': 'ruler_svg', '矮': 'triangle_ruler',
  '长': 'long_ruler', '短': 'short_cut', '宽': 'arrows_lr', '窄': 'pushpin',
  '干净': 'clean_star', '脏': 'dirty_spot', '漂亮': 'pretty_rose',

  // Daily (日常)
  '网络': 'globe_world', '手机': 'mobile_phone', '电视': 'tv_svg', '电话': 'telephone_svg',
  '衣服': 'shirt', '裤子': 'jeans', '鞋': 'shoe', '桌子': 'chair',
  '椅子': 'seat', '床': 'bed', '门': 'door', '窗': 'window',
  '车': 'car', '出租车': 'taxi', '飞机': 'airplane',
  '票': 'ticket', '钱': 'money', '礼物': 'gift', '事情': 'clipboard',
  '意思': 'bulb', '旁边': 'arrows_lr', '前面': 'up', '后面': 'down',
  '左边': 'left', '右边': 'right',
}

export function getEmojiForWord(word: string): string {
  return imgMap[word] || 'question'
}

export function getEmojiUrl(word: string): string {
  return `/images/emoji/${getEmojiForWord(word)}.svg`
}

// New AI-generated illustrations live at /images/words/{id}.jpg and are the
// primary image source. If the JPG is missing (generation failed or still
// running), the UI should fall back to the legacy emoji SVG via an onError
// handler on the <img>.
export function getWordImageUrl(id: number): string {
  return `/images/words/${id}.jpg`
}
